<script lang="ts">
    import type {SpacerDirection, DividerTheme} from './types';
    import type {CssSize} from 'shared/ui-widgets/types';

    export let direction: SpacerDirection;
    export let size: CssSize;
    export let thickness: CssSize = '1px';
    export let theme: DividerTheme = 'default';
</script>

<div class="kp-divider"
     style:width={direction === 'horizontal' ? size : thickness}
     style:height={direction === 'vertical' ? size : thickness}
     style:background-color="var(--border-{theme}"
     role="separator">
</div>

<style>
    .kp-divider {
        flex-shrink: 0;
    }
</style>